export default __webpack_public_path__ + "static/media/background.13204c9b.jpg";